namespace RioERP.Masters {
    export interface TaxCategoryForm {
        Name: Serenity.StringEditor;
    }

    export class TaxCategoryForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.TaxCategory';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TaxCategoryForm.init)  {
                TaxCategoryForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(TaxCategoryForm, [
                    'Name', w0
                ]);
            }
        }
    }
}
